import { TRAILING_PERFORMANCE_DAYS } from '@einhaus/project314-shared';

export const getTradeFilters = () => {
    const trailingRanges = TRAILING_PERFORMANCE_DAYS;

    const tradeFilters = [
        'riskAdjustedScore',
        'profitWeightedScore',
        'avgMonth',
        'numTrades',
        'numTradesLong',
        'numTradesShort',
        'avgTradeProfit',
        'avgTradeProfitShort',
        'avgTradeProfitLong',
        'profitFactor',
        'medianProfitPercent',
        'medianProfitLongPercent',
        'medianProfitShortPercent',
        'returnOnRiskCapital',
        'avgProfitPerDayPercent',
        'medianProfitPerDayPercent',
        'distinctTradingDays',
        'activeMonths',
        'winRateShort',
        'winRateLong',
        'worstMonth',
        'numTradesShort',
        'numTradesLong',
        'winRate'
    ];

    trailingRanges.forEach((range) => {
        for (const prefix of ['', 'Long', 'Short']) {
            tradeFilters.push(`numTrades${prefix}${range}`);
            tradeFilters.push(`avgGain${prefix}${range}`);
            tradeFilters.push(`winRate${prefix}${range}`);
        }
    });

    return tradeFilters;
};
